import { PureComponent } from 'react'
import styled from 'glamorous'
import { $ } from 'utils'
import { Loader, Icon } from 'components'

const Container = styled.div({
  overflow: 'auto',
  height: '100%',
})

const ContainerInner = styled.div({
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'center',
  alignItems: 'flex-end',
  marginTop: 60,
})

const Content = styled.div({
  marginLeft: 25,
  marginBottom: 5
})

const Title = styled.div({
  marginBottom: 9,
  fontSize: 19,
  fontWeight: 700,
  lineHeight: 1.16
})

const Description = styled.div({
  marginBottom: 18,
  fonsSize: 14,
  color: 'var(--grey)'
})

const Actions = styled.div({
  display: 'flex'
})

class EmptyLayout extends PureComponent {

  render() {
    const {title, icon, loading} = this.props
    return (
      loading
        ? $(Loader)
        : $(Container,
        $(ContainerInner,
          $(Icon, {
            type: icon,
            size: 116,
            isHoverable: false,
            color: 'var(--violet)',
          }),
          $(Content,
            $(Title, title),
            $(Description, 'So let\'s fix it right now!'),
            $(Actions, this.props.children)
          )
        )
        )
    )
  }
}

export default EmptyLayout


// WEBPACK FOOTER //
// ./src/components/EmptyLayout.js